import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const SmlouvaProtokol = lazy(() =>
  import('@/modules/ojeta-vozidla/SmlouvaProtokol').then((m) => ({ default: m.SmlouvaProtokol })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/smlouvy/$id/protokol',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaProtokol />
    </Suspense>
  ),
});
